import * as Sentry from '@sentry/react'
import {
	AnyAction,
	applyMiddleware,
	compose,
	createStore,
	Dispatch,
	Middleware,
	Store,
} from 'redux'
import createRootReducer from './reducers'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './sagas'
import { History } from 'history'
import config from '../../../../config'
import logger from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension'
// import { sentryClient } from '../microfrontend'
import { signal } from './connectionMiddleware'

const sagaMiddleware = createSagaMiddleware({
	// find how to inject this, dont need it in storybook directly
	// onError: (error) => sentryClient?.captureException(error),
})
const composeEnhancers = composeWithDevTools({
	trace: true,
	name: 'transaction-client-app',
})

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})

export default function configureStore(): Store<any> {
	const middlewares: Middleware<{}, any, Dispatch<AnyAction>>[] = [
		sagaMiddleware,
		signal,
	]

	if (!config.isProduction) middlewares.push(logger as any)

	const store = createStore(
		createRootReducer(),
		!config.isProduction
			? composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer)
			: compose(applyMiddleware(...middlewares), sentryReduxEnhancer),
	)

	sagaMiddleware.run(rootSaga)

	return store
}
